// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  message: {
    margin: '20px auto',
    padding: '25px',
    maxWidth: '800px',
    width: '100%',
  },
});

type Props = {
  classes: Object,
}

const LoadingMessage = (props: Props) => {
  const { classes } = props;
  return (
    <Typography variant="h4" className={classes.message}>
      Loading...
    </Typography>
  );
};

export default withStyles(styles)(LoadingMessage);
